module.exports = __webpack_public_path__ + "img/transport_directions_filled.e0af424.png";